var _g, _circle, _line, _line2, _line3, _line4, _circle2, _circle3, _line5, _line6, _line7, _line8, _circle4, _g2, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAiming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 203,
    viewBox: "0 0 203 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_749_31492)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 102.222,
    cy: 101.685,
    r: 25.651,
    fill: "#FDE1B9",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 102.326,
    cy: 101.789,
    r: 12.6665,
    stroke: "#FDE1B9",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 102.537,
    y1: 93.9814,
    x2: 102.537,
    y2: 109.018,
    stroke: "#FDE1B9"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 102.537,
    y1: 93.9814,
    x2: 102.537,
    y2: 109.018,
    stroke: "#FDE1B9"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 94.5186,
    y1: 101,
    x2: 109.556,
    y2: 101,
    stroke: "#FDE1B9"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 94.5186,
    y1: 101,
    x2: 109.556,
    y2: 101,
    stroke: "#FDE1B9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.037,
    cy: 101.5,
    r: 51.0401,
    stroke: "#FDE1B9",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.037,
    cy: 101.5,
    r: 59.2917,
    stroke: "#FDE1B9",
    strokeWidth: 4,
    strokeDasharray: "8 8"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 25.7778,
    y1: 102,
    x2: 0.0000534058,
    y2: 102,
    stroke: "#FDE1B9"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 203,
    y1: 102,
    x2: 177.222,
    y2: 102,
    stroke: "#FDE1B9"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 101,
    y1: 25.7778,
    x2: 101,
    y2: 0.0000533839,
    stroke: "#FDE1B9"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 101,
    y1: 203,
    x2: 101,
    y2: 177.222,
    stroke: "#FDE1B9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.037,
    cy: 101.5,
    r: 45.1797,
    stroke: "#FDE1B9",
    strokeDasharray: "2 2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_749_31492)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 102.037,
    cy: 101.5,
    r: 65.5926,
    stroke: "#FDE1B9",
    strokeWidth: 2,
    strokeDasharray: "2 2",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 101.5C192.5 151.203 151.984 191.5 102 191.5C52.0156 191.5 11.5 151.203 11.5 101.5C11.5 51.797 52.0156 11.5 102 11.5C151.984 11.5 192.5 51.797 192.5 101.5Z",
    stroke: "#FDE1B9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_749_31492",
    x: 60.5706,
    y: 60.0337,
    width: 83.302,
    height: 83.3018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.882353 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_749_31492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_749_31492",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_749_31492",
    x: 27.4445,
    y: 26.9072,
    width: 149.185,
    height: 149.185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.882353 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_749_31492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_749_31492",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiming);
export default __webpack_public_path__ + "static/media/aiming.cdf5806c4686913131b4c1f9e87e0358.svg";
export { ForwardRef as ReactComponent };